import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { GDSThemeProvider, loadTheme, archetypeLightTheme } from '@leagueplatform/genesis-core';
import { Home } from './pages/Home';
const theme = loadTheme(archetypeLightTheme);

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Home />,
    },
  ]);

  return (
    <GDSThemeProvider theme={theme}>
      <RouterProvider router={router} fallbackElement={<p>loading...</p>} />
    </GDSThemeProvider>
  );
}

export default App;
